import { styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const PageSubtitle = styled("p")({
  margin: "0 0 24px",
  fontSize: "15px",
  lineHeight: 1.5,
  color: colors.text.muted,
  fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
});
